export const GOOGLE_MARKER_SIGNATURE = 'Google marker';

export const DEFAULT_MAP_CENTER = { lat: 48, lng: 10.9571603 };
export const DEFAULT_MAP_ZOOM = 6;

export const MAP_TYPES = {
  HYBRID: 'hybrid',
  ROADMAP: 'roadmap',
  SATELLITE: 'satellite',
  TERRAIN: 'terrain',
} as const;

export type MapTypeKeys = keyof typeof MAP_TYPES;
export type MapType = (typeof MAP_TYPES)[MapTypeKeys];
